import { SequenceDetailsQuery } from '~/data';
import { ItemIds, ROOT, RootDefinition } from '../items';
import { ItemDefinition } from '../items/Item';
import { AudioHelper } from './itemHelpers/AudioHelper';
import {
  BackgroundHelper,
  BackgroundHelperWithLogo
} from './itemHelpers/BackgroundHelper';
import { ApiItems, ItemOfType } from './itemHelpers/types';

type Mapper = (
  item: ApiItems[0]
) => ItemDefinition<ItemIds> | Array<ItemDefinition<ItemIds>> | null;

export function translate(
  sequence: SequenceDetailsQuery['sequence'],
  cb: Mapper,
  showLogo?: boolean
) {
  const mapper: Mapper = item => {
    const result = cb(item);
    if (result) return result;

    switch (item.__typename) {
      case 'Background':
        return showLogo
          ? BackgroundHelperWithLogo(item as ItemOfType<'Background'>)
          : BackgroundHelper(item as ItemOfType<'Background'>);
      default:
        return null;
    }
  };

  const items = [...(sequence.items || [])]
    .sort((a, b) => (a.position || 0) - (b.position || 0))
    .map(mapper)
    .concat([AudioHelper(sequence)])
    .flat()
    .filter((item): item is ItemDefinition<ItemIds> => Boolean(item));

  const rootDefinition: RootDefinition = {
    id: '0',
    type: ROOT,
    values: void {},
    items
  };

  return {
    ...rootDefinition,
    withTransform: (transformer: (root: RootDefinition) => RootDefinition) =>
      transformer(rootDefinition)
  };
}
